import { render, staticRenderFns } from "./LogDetailsDialog.vue?vue&type=template&id=6d233876&scoped=true&"
import script from "./LogDetailsDialog.vue?vue&type=script&lang=ts&"
export * from "./LogDetailsDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d233876",
  null
  
)

export default component.exports